import { RouteRecordRaw } from 'vue-router';
import { Role } from '@/router/enum';

export const publicRoute: RouteRecordRaw[] = [
  {
    path: '/download-zone',
    name: 'DownloadZone',
    component: () => import('@/views/download-zone/index.vue'),
    meta: {
      title: '下载中心',
      key: 'download-zone',
      permission: [Role.FREE],
    },
  },
  {
    // 产品详情（安装包列表），:key 口径 = Electron 数字 id / WPF `${id}_wpf`
    path: '/download-zone/:key',
    name: 'DownloadZoneDetail',
    component: () => import('@/views/download-zone/detail.vue'),
    meta: {
      title: '下载中心',
      key: 'download-zone-detail',
      permission: [Role.FREE],
    },
  },
];
